import {
	Box,
	Card,
	Show,
	Stack,
	Image,
	Divider,
	AbsoluteCenter,
} from "@chakra-ui/react";

import { ContactForm } from "../components/ContactForm/ContactForm";
import { ContactInfo } from "../components/contactInfo";

import { emailLink, smsLink } from "../helpers";

import bra from "../media/bra.jpg";

export const Contact = () => {
	return (
		<Stack
			id="contact"
			align="center"
			pt={{ base: "4", md: "8" }}
			gap={{ base: "5", md: "8" }}
		>
			<Show below="md">
				<Card position="relative" w="100%">
					<Image
						w="100%"
						h="300px"
						src={bra}
						alt="experience"
						objectFit="cover"
						onContextMenu={(e) => e.preventDefault()}
					/>
					<AbsoluteCenter>
						<Stack w="sm" p="4" rounded="3" align="center" bg="brand.light">
							<ContactInfo
								isMobile
								label="text me at"
								value="0493 439 302"
								link={smsLink}
							/>
							<Divider borderColor="brand.contrast" />
							<ContactInfo
								isMobile
								label="email me at"
								value="hello@lulureynolds.com.au"
								link={emailLink}
							/>
						</Stack>
					</AbsoluteCenter>
				</Card>
			</Show>

			<Show above="md">
				<Card position="relative" w="100%">
					<Image
						w="100%"
						h="360px"
						src={bra}
						rounded="3"
						alt="experience"
						objectFit="cover"
						onContextMenu={(e) => e.preventDefault()}
					/>
					<AbsoluteCenter>
						<Box p="4" rounded="3" bg="brand.light">
							<ContactForm />
						</Box>
					</AbsoluteCenter>
				</Card>
			</Show>
		</Stack>
	);
};
